import React from 'react';

import classes from './HomepageWrap.module.pcss';

interface Props {
	children: any
}

const HomepageWrap = ({children}: Props) => (
	<div className={classes.HomepageWrap}>
		{children}
	</div>
);

export default HomepageWrap;
